<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="1080px">
      <template v-slot:activator="{ on, attrs }">
        <!-- <v-btn color="primary" outlined dark v-bind="attrs" v-on="on"> -->
        <v-icon v-bind="attrs" v-on="on">mdi-printer</v-icon>
        <!-- </v-btn> -->
      </template>

      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Gambia Ports Authority - Delivery Charge Sheet
        </v-card-title>
        <!-- <v-card-text> -->
        <v-container fluid>
          <div id="print-div">
            <v-row>
              <v-col cols="12" sm="8" md="4" class="pt-2 mb-2">
                <div class="d-print-block">
                  <v-img
                    :lazy-src="logoURI"
                    max-height="150"
                    max-width="150"
                    :src="logoURI"
                  ></v-img></div
              ></v-col>
              <v-col
                cols="12"
                sm="4"
                md="4"
                class="pt-10 mb-2 font-weight-bold"
              >
                <div class="text-h5 mb-0 text-center">
                  GAMBIA PORTS AUTHORITY <br />
                  DELIVERY CHARGE SHEET
                </div>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-col cols="12" sm="12" class="pt-0 mb-2">
                  Print Date: {{ current_date_time }}
                  <br />

                  <span v-if="do_data">
                    <span class="pt-1 mb-0 grey lighten-3"
                      >Sheet #:

                      {{ delivery_order.number }} </span
                    ><br />
                    Destination Type:
                    <span v-if="delivery_order.is_transit">
                      TRANSIT
                    </span>
                    <span v-else>
                      DOMESTIC/LOCAL
                    </span>
                  </span>
                </v-col>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="8" md="4" class="pt-2 mb-2">
                <v-col cols="12" sm="12" class="mb-2 font-weight-bold"
                  >Consignee Details:</v-col
                >
                <v-col cols="12" sm="12" class="pt-0 mb-2">
                  Consginee:
                  <span v-if="do_data">
                    {{ delivery_order.consignee_fullname }}
                    <br />
                    Address:

                    {{ delivery_order.consignee_address }}
                    <br />
                    Email:

                    {{ delivery_order.consignee_email }}
                    <br />
                    Contact: N/A
                  </span>
                </v-col></v-col
              >
              <v-col
                cols="12"
                sm="4"
                md="4"
                class="pt-10 mb-2 font-weight-bold"
              >
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-col cols="12" sm="12" class="mb-2 font-weight-bold"
                  >Delivery Order Details:</v-col
                >
                <v-col cols="12" sm="12" class="pt-0 mb-2">
                  DO Number:
                  <span v-if="do_data">
                    {{ delivery_order.do_number }}
                    <br />
                    BL Number:

                    {{ delivery_order.bl_number }}
                    <br />

                    No. of Cargos:{{ delivery_order.item_quantity }} <br />
                    Vessel:

                    {{ vessel.vessel_name }}
                    <br />
                    Voyage Number:

                    {{ vessel.voyage_number }}
                  </span>
                </v-col>
              </v-col>
            </v-row>
            <!--   <v-row>
              <v-col cols="12" sm="12" class="pt-2 mb-2 font-weight-bold">
                <div class="text-h5 mb-6 text-center">
                  Charge Sheet
                </div>
              </v-col>
            </v-row> -->
            <v-row>
              <v-col cols="12" sm="12" class="pt-2 mb-2 font-weight-bold">
                <!-- DELIVERY ORDER ITEM LIST -->
                <item-list :do_items_list="delivery_order_items" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="8" md="6" class="pt-2 mb-2">
                <v-col cols="12" sm="12" class="mb-2 font-weight-bold"
                  >Rating Details:</v-col
                >
                <v-col cols="12" sm="12" class="pt-0 mb-2">
                  Rated by:
                  <span v-if="do_data">
                    {{ delivery_order.current_username }}
                    <br />
                    Date Rated:

                    {{ delivery_order.date_time_added }}
                    <br />
                    Verified by:

                    {{ delivery_order.verified_by }}
                    <br />
                    <span class="pt-1 mb-0 grey lighten-3">
                      Signature:
                      ........................................................
                    </span>
                  </span>
                </v-col></v-col
              >
              <v-col
                cols="12"
                sm="4"
                md="2"
                class="pt-10 mb-2 font-weight-bold"
              >
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <v-col cols="12" sm="12" class="mb-2 font-weight-bold"
                  >Charges Details:</v-col
                >
                <v-col cols="12" sm="12" class="pt-0 mb-2">
                  Amount Due (GMD):
                  <span v-if="do_data">
                    <!--{{ delivery_order.total_charge  }}-->
                    {{ getAmountDue() }}
                    <br />
                    New Charges (GMD):

                    {{ delivery_order.new_charges }}
                    <br />
                    Prev. Charges (GMD):

                    {{ delivery_order.total_charge }}
                    <br />
                    Waived Amount (GMD):

                    {{ delivery_order.waved_amount }}
                    <br />
                    Days Charged:

                    {{ delivery_order.final_days_spend }}
                  </span>
                </v-col>
              </v-col>
            </v-row>
          </div>
        </v-container>
        <!-- </v-card-text> -->
        <v-card-actions class="d-print-none">
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialog = false">
            Close
          </v-btn>
          <!--<v-btn color="blue darken-1" text @click="print()">
            <v-icon>mdi-printer</v-icon>
            Print
          </v-btn> -->
          <v-btn color="blue darken-1" text @click="generateReport">
            <v-icon>mdi-printer</v-icon>
            Download & Print
          </v-btn>
          <!-- <v-btn color="blue darken-1" text @click="printReport">
            <v-icon>mdi-printer</v-icon>
            Print Sheet
          </v-btn> -->
        </v-card-actions>
      </v-card>
      <div>
        <vue-html2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="false"
          :preview-modal="true"
          :paginate-elements-by-height="1400"
          filename="Delivery Order"
          :pdf-quality="2"
          :manual-pagination="false"
          pdf-format="a4"
          pdf-orientation="portrait"
          pdf-content-width="800px"
          @progress="onProgress($event)"
          @hasStartedGeneration="hasStartedGeneration()"
          @hasGenerated="hasGenerated($event)"
          ref="html2Pdf"
        >
          <section slot="pdf-content">
            <!-- PDF Content Here -->
            <div id="pdf-content"></div>
          </section>
        </vue-html2pdf>
      </div>
      <div id="pdf-content-report"></div>
    </v-dialog>
  </v-row>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const itemList = () => import("./partial-item-list");
import moment from "moment";
import printJS from "print-js";
import VueHtml2pdf from "vue-html2pdf";
//import { jsPDF } from "jspdf";
//import { CommonServices } from "../../services/common.services";
import { LOGO_URI } from "@/services/config.service";

//const vesselNamespace = createNamespacedHelpers("vessels");
const deliveryOrderNamespace = createNamespacedHelpers("delivery_orders");
const departedVesselNamespace = createNamespacedHelpers("departed_vessels");

export default {
  name: "dialog-print-charge-sheet",
  components: {
    itemList,
    VueHtml2pdf
  },
  data: () => ({
    dialog: false,
    do_report: null,
    //vessels: "",
    // vessel: null,
    // voyage_no: null,
    do_items: null,
    do_data: null,
    time: null,
    shipping_line: null,
    logoURI: LOGO_URI + "gpa_logo.png",
    activePicker: null,
    // date: new Date(),
    current_date: moment().format("YYYY-MM-DD"),
    current_date_time: moment().format("YYYY-MM-DD hh:mm"),
    menu: false,
    modal: false,
    valid: true,
    errors: null,
    slug: "slug",
    error: false,
    htmlToPdfOptions: {
      margin: 2.5,
      image: {
        type: "png",
        quality: 2
      },
      html2canvas: {
        scale: 1,
        useCORS: true
      },
      jsPDF: {
        //unit: "in",
        format: "a4",
        orientation: "portrait"
      }

      //   :html-to-pdf-options="htmlToPdfOptions"
    }
    // nameRules: [v => !!v || "Item Name is required"],
    //textRules: [v => !!v || "Field is required"]
  }),
  computed: {
    ...deliveryOrderNamespace.mapState({
      delivery_order: state => state.delivery_order,
      delivery_order_items: state => (state.do_items ? state.do_items : []),
      sheet_number: state => state.sheet_number
    }),
    ...departedVesselNamespace.mapState({
      loading: state => state.loading,
      vessel: state => state.selected_vessel
    })
    /*...vesselNamespace.mapState({
      vessels: state => state.vessels
    })*/
  },
  watch: {
    dialog(val) {
      if (val) this.initiate();
    }
  },

  mounted() {
    //this.start_up();
    //this.getVessels();
   // console.log("url", this.logoURI);
  },
  methods: {
    //...departedVesselName.mapActions(["addDepartedVessel"]),
    ...deliveryOrderNamespace.mapActions(["aGetJSReport"]),
    generateReport() {
      //using this one
      const report = "GPADeliveryChargeSheet";
      const format = "pdf";
      const params = { do_id: this.delivery_order.id };

      const payload = {
        report: report,
        format: format,
        params: params
      };

      //this.$refs.html2Pdf.generatePdf();
      const resp = this.aGetJSReport(payload);

      Promise.resolve(resp).then(
        function(value) {
          this.do_report = value;
          this.generatePDF(value, payload);
          // console.log("report from comp", this.do_report);
        }.bind(this)
      );
    },
    generatePDF(resp, params) {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `${params.report}_${params.params.do_id}.${params.format}`
      ); //or any other extension
      document.body.appendChild(link);
      link.click();
      // console.log("print");
      //
    },
    onProgress() {},
    printReport() {
      //let print_div = document.createElement("print-div")
      // console.log("generate from print-charge-sheet");
      let div = document.getElementById("print-div");
      document.getElementById("pdf-content").prepend(div);
      this.$refs.html2Pdf.generatePdf();
    },
    getAmountDue() {
      let amount = 0;
      const regp = /[^0-9.-]+/g;
      const current_rent = this.delivery_order.total_charge
        ? parseFloat(this.delivery_order.total_charge.replace(regp, ""))
        : this.delivery_order.total_charge;
      const new_rent = this.delivery_order.new_charges
        ? parseFloat(this.delivery_order.new_charges.replace(regp, ""))
        : this.delivery_order.new_charges;
      const waived_amount = this.delivery_order.waved_amount
        ? parseFloat(this.delivery_order.waved_amount)
        : this.delivery_order.waved_amount;

      if (
        !this.delivery_order.waved_amount &&
        this.delivery_order.new_charges <= 0
      ) {
        //  console.log("hit this 1")
        amount = this.delivery_order.total_charge;
      } else if (
        !this.delivery_order.waved_amount &&
        this.delivery_order.new_charges > 0
      ) {
        // console.log("hit this 2")
        amount = new_rent - current_rent;
      } else if (
        this.delivery_order.waved_amount &&
        this.delivery_order.new_charges > 0
      ) {
        //return parseInt(this.delivery_order.new_charges) - parseInt(this.delivery_order.waved_amount)
        // console.log("hit this 3")
        amount = new_rent - current_rent - waived_amount;
      } else if (
        this.delivery_order.waved_amount &&
        !this.delivery_order.new_charges
      ) {
        // console.log("hit this 4")
        amount = current_rent - waived_amount;
      } else {
        return amount;
      }
      return amount; //.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    },
    onProgress() {},

    dirty() {},
    initiate() {
      this.do_data = true;
      //console.log("from charge sheet", this.delivery_order);
      //console.log("initiate");
    },
    print() {
      //window.print();
      printJS({
        printable: "print-div",
        type: "html",
        targetStyles: ["*"]
      });
    },

    close() {
      this.dialog = false;
    }
  }
};
</script>
<style scoped>
@media print {
  #print-div {
    background-color: white;
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    margin: 0;
    padding: 15px;
    font-size: 14px;
    line-height: 18px;
  }
}
</style>
